<app-portal-collapsible
    title="Versicherte Schüler"
    icon="group"
>
    <p class="fs:s fw:semibold">Mit dieser Versicherung sind die Instrumente der folgenden Schüler/innen versichert:</p>
    <dl class="grid-container vertical-gutter-lg">
        @for (item of klasse; track item; let i = $index) {
            <app-portal-widget-details
                class="g-12 sm:g-12"
                heading="{{ i + 1 }}. Schüler/in"
                detail="{{ item.Person }}"
            />
        }
    </dl>
</app-portal-collapsible>
